import React, {Fragment, useContext, useState} from 'react';
import {useCurrentOrder, useCurrentOrderTickets, useLookups} from "./order-form-hooks.";
import OrderForm from "./order-form";
import {useHistory, useParams} from "react-router-dom";
import {isNewTransferOrder, Order, OrderFormValues} from '../../../app/models/order';
import {getEditModeBreadcrumbs, getOrderFormTitle} from './order-form-options';
import {Ticket} from "../../../app/models/Ticket";
import {Store} from '../../../app/stores/store-root';
import MessageModal from "../../../app/common/message-modal";
import {observer} from 'mobx-react-lite';

const OrderFormContainer = () => {


    const store = useContext(Store);
    const history = useHistory();
    const {CloseTicket} = store.SupportTickets;
    const {CancelOrder, RejectOrder, PlaceOrder, UpdateOrder, PayOrder,SetOrderAsInProgress,ApproveOrder} = store.Orders
    const {openModal, closeModal} = store.Modal

    const [Loading, SetLoading] = useState();
    useLookups(SetLoading);
    const {orderId} = useParams();
    const {Order, ShowPayOrderFields,EnableOrderFormFields,ShowOrderActionsMenu} = useCurrentOrder(orderId, SetLoading);
    const tickets = useCurrentOrderTickets(orderId, SetLoading);
    const breadcrumbNavigation = getEditModeBreadcrumbs(orderId);
    const title = getOrderFormTitle(orderId);

    const onCloseTicket = async (ticket: Ticket) => {
        await CloseTicket(ticket);
    };

        const onCancelOrder = async (order: OrderFormValues) => {
        try {
            await CancelOrder(order);
            const message = `Order ${order.Reference} has been cancelled successfully.`
            openModal(
                <MessageModal message={message} success={true}/>
            );
            history.push("/");
        } catch (error) {
            closeModal();
            const message = `Unable to cancel order ${order.Reference}. The following error message returned from the server. ${error.response.data.error}.`
            store.Modal.openModal(
                <MessageModal message={message} success={false}/>
            );
        }
    }

    const onRejectOrder = async (order: OrderFormValues) => {

        try {
            await RejectOrder(order);
            const message = `Order ${order.Reference} has been rejected successfully.`
            openModal(
                <MessageModal message={message} success={true}/>
            );
            history.push("/");
        } catch (error) {
            closeModal();
            const message = `Unable to reject order ${order.Reference}. The following error message returned from the server. ${error.response.data.error}.`
            store.Modal.openModal(
                <MessageModal message={message} success={false}/>
            );
        }

    }

    const onSubmitOrder = async (order: OrderFormValues) => {
        if (orderId) {
            try {
                await UpdateOrder(order);
                const message = `Order ${order.Reference} updated sucessfully.`
                store.Modal.openModal(
                    <MessageModal message={message} success={true}/>
                );
                history.push("/");
            } catch (error) {
                const message = `Order ${order.Reference} cannot be updated. The following error message returned from the server. ${error.response.data.error}`
                store.Modal.closeModal();
                store.Modal.openModal(
                    <MessageModal message={message} success={false}/>
                );
            }
        } else {
            try {
                await PlaceOrder(order);
                const message = `Order ${order.Reference} placed sucessfully.`
                store.Modal.openModal(
                    <MessageModal message={message} success={true}/>
                );
                history.push("/");
            } catch (error) {
                const message = `Order ${order.Reference} cannot be placed. The following error message returned from the server. ${error.response.data.error}`
                store.Modal.closeModal();
                store.Modal.openModal(
                    <MessageModal message={message} success={false}/>
                );
            }
        }
    }

    const onPayOrder = async ( order: OrderFormValues)=>{
        try {
            await PayOrder(order);
            const message = `Order ${order.Reference} has been paid successfully.`
            openModal(
                <MessageModal message={message} success={true}/>
            );
            history.push("/");
        } catch (error) {
            closeModal();
            const message = `Unable to pay order ${order.Reference}. The following error message returned from the server. ${error.response.data.error}.`
            store.Modal.openModal(
                <MessageModal message={message} success={false}/>
            );
        }
    }

    const onApproveOrder=async(order:OrderFormValues)=>{
        try {
            await ApproveOrder(order);
            const message = `Order ${order.Reference} has been approved successfully.`
            openModal(
                <MessageModal message={message} success={true}/>
            );
            history.push("/");
        } catch (error) {
            closeModal();
            const message = `Unable to approve order ${order.Reference}. The following error message returned from the server. ${error.response.data.error}.`
            store.Modal.openModal(
                <MessageModal message={message} success={false}/>
            );
        }
    }

    const onOrderInProgress=async(order:OrderFormValues)=>{


        try {
            await SetOrderAsInProgress(order);
            const message = `Order ${order.Reference} has been set to In progress successfully.`
            openModal(
                <MessageModal message={message} success={true}/>
            );
            history.push("/");
        } catch (error) {
            closeModal();
            const message = `Unable to set order ${order.Reference} to In Progress status. The following error message returned from the server. ${error.response.data.error}.`
            store.Modal.openModal(
                <MessageModal message={message} success={false}/>
            );
        }
    }


    return (
        <Fragment>
            <OrderForm Order={Order}
                       ReadOnly={!EnableOrderFormFields}
                       Tickets={tickets}
                       Loading={Loading}
                       ShowActions={ShowOrderActionsMenu}
                       Navigation={breadcrumbNavigation}
                       Title={title}
                       CloseTicket={onCloseTicket}
                       CancelOrder={onCancelOrder}
                       RejectOrder={onRejectOrder}
                       SubmitOrder={onSubmitOrder}
                       PayOrder={onPayOrder}
                       ShowBeneficiaryFields={ShowPayOrderFields}
                       ApproveOrder={onApproveOrder}
                       MakeOrderInprogrees={onOrderInProgress}
            />
        </Fragment>
    );
};

export default observer(OrderFormContainer);